module.exports = __webpack_public_path__ + "images/psp/PSPHero/climate-controlled-hero.webp";